// RouteProgress — thin top progress bar that animates whenever the route changes.
// CSS-only animation, no library. Listens to react-router location.
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function RouteProgress() {
    const location = useLocation();
    // phase: idle | loading | done
    const [phase, setPhase] = useState("idle");
    const [key, setKey] = useState(0);
    // Skip the very first mount so the bar doesn't flash on page-load.
    const [primed, setPrimed] = useState(false);

    useEffect(() => {
        if (!primed) {
            setPrimed(true);
            return;
        }
        // Force-remount the bar so the keyframes restart cleanly.
        setKey((k) => k + 1);
        setPhase("loading");
        const t1 = setTimeout(() => setPhase("done"), 210);
        const t2 = setTimeout(() => setPhase("idle"), 510);
        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, location.search]);

    if (phase === "idle") return null;

    const styles = `
        @keyframes uavsimnet-route-grow { from { width: 0%; } to { width: 80%; } }
        @keyframes uavsimnet-route-finish {
            from { width: 80%; opacity: 1; }
            to   { width: 100%; opacity: 0; }
        }
    `;

    const barStyle =
        phase === "loading"
            ? {
                  animation: "uavsimnet-route-grow 200ms ease-out forwards",
              }
            : {
                  animation: "uavsimnet-route-finish 250ms ease-out forwards",
              };

    return (
        <>
            <style>{styles}</style>
            <div
                key={key}
                aria-hidden="true"
                data-testid="route-progress"
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    height: "2px",
                    background: "var(--ux-accent)",
                    boxShadow: "0 0 8px var(--ux-accent)",
                    zIndex: 9999,
                    pointerEvents: "none",
                    width: 0,
                    ...barStyle,
                }}
            />
        </>
    );
}
